/**
 * Layout-only parent route for /deals/*.
 *
 * In TanStack Router file-based routing, every parent in the chain
 * must render `<Outlet />` for nested children to mount. The list page
 * itself lives in `_app.deals.index.tsx`; this file just renders the
 * outlet so child routes (`/deals/$dealId`, `/deals/new`, `/deals/trash`)
 * can mount under `_app/deals`.
 *
 * Found via `scripts/smoke_visual.py` after the table-layout overhaul
 * accidentally collapsed the list and parent into one file, breaking
 * deep-link navigation to detail pages.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/deals")({
  component: DealsLayout,
});

function DealsLayout() {
  return <Outlet />;
}
